import React from "react";
import ReportOne from "../../../../assets/images/report-one.png";
import ReportTwo from "../../../../assets/images/report-two.png";
import ReportThree from "../../../../assets/images/report-three.png";

// Reusable FeatureCard component (as you defined)
const FeatureCard = ({
  image,
  label,
  description,
  subtitle,
  imageLeft,
  hideLine = false,
}) => {
  return (
    <div className="bg-[#F5FAFF] w-full">
      <div
        className={`flex flex-col ${
          imageLeft ? "md:flex-row" : "md:flex-row-reverse"
        } lg:h-[412px]`}
      >
        <div className="w-full md:w-1/2">
          <div className="h-full lg:h-[412px] overflow-hidden">
            <img
              src={image}
              alt={label}
              className="w-full h-full object-contain"
            />
          </div>
        </div>
        <div className="w-full md:w-1/2">
          <div className="h-full lg:h-[412px] overflow-auto flex items-center">
            <div className="p-6 md:p-8 flex flex-col justify-center h-full w-full pr-4 lg:pr-8">
              {/* <p className="text-sm text-[#4B68C6] font-semibold mb-2 flex items-center font-['Poppins']">
                {!hideLine && (
                  <span className="w-4 h-0.5 bg-[#4B68C6] mr-2"></span>
                )}
                Smart Report
              </p> */}
              <h2 className="text-xl md:text-2xl font-semibold text-[#121212] font-['Poppins'] mb-2">
                {label}
              </h2>
              <p
                style={{ fontSize: "13px", textAlign: "justify" }}
                className="text-[#4A4C56] font-light leading-[21px] font-['Poppins']"
              >
                {description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SmartReportContent = () => {
  const features = [
    {
      image: ReportOne,
      label: "Real-Time Event Insights",
      imageLeft: true,
      description: `Smart Report opens with real-time data directly from the database—giving you a live view of your system's activities.
Events such as access attempts, admin actions, or system changes are displayed with full detail and timestamps.
You can instantly switch views by selecting Workspace, Copy from Database, or Log Restore, depending on your need.
Every event is tagged with critical information like EventName, PersonName, DeviceName, and Message.
This flexibility allows teams to monitor current activity, view backed-up data, or work on filtered event sets.
Whether you’re tracking live events or reviewing historical data, it’s all one click away.
With built-in filtering and search, finding the right information is fast and intuitive.
Smart Report ensures you never miss a moment, no matter where the data comes from.`,
    },
    {
      image: ReportTwo,
      label: "Customizable & Searchable Table",
      imageLeft: false,
      description: `By default, Smart Report loads database data in a dynamic, customizable table format.
Users can easily switch the source to Workspace, Log Restore, or Copy from Database to suit their task.
Select and reorder columns like LogTime, CredentialNo, or AckUser to match your workflow.
Use advanced filters to focus on specific events, time periods, users, or system components.
Once filtered, export the visible data as a CSV or PDF with a single click.
This level of flexibility ensures every team member sees only what they need, how they need it.
The table is fully responsive and supports real-time interaction on all devices.
From monitoring to reporting, it’s a tool that works the way you do.`,
    },
    {
      image: ReportThree,
      label: "Complete Audit Trail & Export Options",
      imageLeft: true,
      description: `Smart Report provides a full trace of all security-related actions, no matter the data source.
Whether viewing current logs, restored archives, or workspace edits, every event is fully documented.
Logs include who performed the action, what changed, and when—with support for comments and acknowledgments.
Use filters to narrow results, then instantly export or print the view in CSV or PDF formats.
This makes auditing, investigations, or compliance checks fast, clear, and reliable.
The ability to switch between Database, Workspace, and Log Restore views adds powerful flexibility.
No event goes untracked—your complete access control history is always at your fingertips.
It’s transparency, accountability, and export-ready precision in one unified report tool.`,
    },
  ];

  return (
    <>
      <div className="cloud-bg flex justify-center items-center">
        <p className="bg-text text-center">Smart Report</p>
      </div>
      <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-6 md:py-8 lg:py-20">
        {features.map((feature, index) => (
          <FeatureCard
            key={index}
            image={feature.image}
            label={feature.label}
            description={feature.description}
            imageLeft={feature.imageLeft}
            subtitle="Smart Report"
          />
        ))}
      </div>
    </>
  );
};
